<div class="pdf-inspector-error-modal">
  <button mat-icon-button class="pdf-inspector-error-modal__close" [mat-dialog-close]="false"
    [attr.aria-label]="'common.closeBtn' | transloco">
    <mat-icon class="fa" fontSet="fas" fontIcon="fa-times"></mat-icon>
  </button>

  <div class="pdf-inspector-error-modal__icon">
    <mat-icon class="fa-lg" fontSet="fas" fontIcon="fa-times"></mat-icon>
  </div>

  <h2 class="pdf-inspector-error-modal__title">{{ titleKey | transloco }}</h2>
  <p class="pdf-inspector-error-modal__subtitle">{{ subtitleKey | transloco }}</p>

  <button mat-flat-button color="primary" class="pdf-inspector-error-modal__retry" (click)="retry()">
    {{ 'pdfInspector.errorModal.retryBtn' | transloco }}
  </button>
</div>
